export const eventType = {
  itemCreated: "crudItemCreated",
  itemUpdated: "crudItemUpdated",
  itemDeleted: "crudItemDeleted",
  clientChanged: "clientChanged",
  clientDetailsChanged: "clientDetailsChanged",
  quoteUpdating: "qouteUpdating",
  quoteUpdated: "qouteUpdated",
  qouteCreated: "qouteCreated",
  quoteSent: "quoteSent",
  quoteReplicated: "quoteReplicated",
  qouteAccepted: "qouteAccepted",
  qouteUnaccepted: "qouteUnaccepted",
  qouteDeclined: "qouteDeclined",
  qouteUndeclined: "qouteUndeclined",
  quoteDeleted: "quoteDeleted",
  quoteClosed: "quoteClosed",
  locationSurchargeUpdated: "locationSurchargeUpdated",
  locationAliasUpdated: "locationAliasUpdated",
  manualQuoteUpdated: "manualQuoteUpdated",
  quoteSendError: "quoteSendError",
  userProgressToggle: "userProgressToggle",
  tariffLocationChanged: "tariffLocationChanged",
  organizationLogoChanged: "organizationLogoChanged",
  dashboardContainerLoadChanged: "dashboardContainerLoadChanged",
  lclRateWeightUnitChanged: "lclRateWeightUnitChanged",
  quoteAverageMarginUpdated: "quoteAverageMarginUpdated",
  quoteLocationSurchargeCreatedAndReordered:
    "quoteLocationSurchargeCreateFinish",
  quoteLocationSurchargeError: "quoteLocationSurchargeError",
  quoteLocationSurchargeDeleted: "quoteLocationSurchargeDeleted",
};
